module.exports = __webpack_public_path__ + "static/media/Travelling Luggages.571a4d6c.jpg";